import { get } from 'lodash/fp'
import { isUnifiedPlan } from '../../sdpUtils/sdpSemantics'
import { setTransceiverDirection } from '../../sdpUtils/transceiverUtils'

/**
 * Sets the direction of transceivers.
 * @method setTransceiversDirection
 * @param {string} targetDirection The desired direction to set the transceivers to.
 * @param {Object} [options] Options for specifying which transceivers should be affected. They are ordered by priority.
 * @param {Array} [options.trackIds] The optional list of track ids whose transceivers we want to set the direction of.
 * @return {Object} An object containing an `error` flag and  an array `failures` of transceivers whose directions weren't changed.
 */
export default function setTransceiversDirection (targetDirection, options = {}) {
  const { proxyPeer, config, log } = this
  log.info(`Setting transceiver direction to ${targetDirection}.`)

  if (isUnifiedPlan(config.rtcConfig.sdpSemantics)) {
    let transceivers = proxyPeer.getTransceivers()

    if (options.trackIds) {
      transceivers = transceivers.filter(transceiver => {
        return (
          options.trackIds.includes(get(['sender', 'track', 'id'], transceiver)) ||
          options.trackIds.includes(get(['receiver', 'track', 'id'], transceiver))
        )
      })
    }

    const failures = []
    transceivers.forEach(transceiver => {
      if (!setTransceiverDirection(transceiver, targetDirection)) {
        failures.push(transceiver)
      }
    })
    return {
      error: failures.length !== 0,
      failures
    }
  } else {
    log.info('Transceiver direction modification is only available in unified-plan.')
    return {
      error: true
    }
  }
}
